import React from "react"

import Layout from "../components/Layout"
import PageHeader from "../components/PageHeader"
import SectionTitle from "../components/SectionTitle"
import Faq from "../components/Faq"
import PhotoSlider from "../components/Sliders/PhotoSlider"

const Students = () => (
  <Layout title="Students">
    <PageHeader
      className="students-header"
      title="JOIN US"
      subtitle="Our Students"
    />

    {/* ================= Start Intro Section ================= */}
    <section className="section-sm shaded">
      <div className="container">
        <SectionTitle title="Our Goal" hasPadding={true}>
          <p>
            As part of our mission here at UCLA, CYC looks to create the next
            generation of community leaders. You’ll not only be challenged to
            think critically and creatively, but you’ll also be able to make a
            lasting impact and grow professionally.
          </p>
        </SectionTitle>
        <PhotoSlider>
          {["1", "2", "3", "4", "5"].map(function (num) {
            return (
              <div key={num}>
                <img
                  className="slick-image"
                  src={`/images/students-carousel/${num}.jpg`}
                  alt={`students-carousel-${num}`}
                />
              </div>
            )
          })}
        </PhotoSlider>
      </div>
    </section>
    {/* ================= End Intro Section ================= */}

    {/* ================= Start Process Section ================= */}
    <section className="section-sm services">
      <div className="container">
        <SectionTitle title="Our Process" hasPadding={true}>
          <a href="apply">
            <button id="apply" className="btn btn-light">
              &#9656; Apply Now!
            </button>
          </a>
          {/* <p>
            Thank you for your interest in CYC at UCLA. Applications for Winter
            2020 recruitment will open on 1/18.
          </p> */}
        </SectionTitle>

        <div className="row">
          {/* Single Service Item */}
          <div className="col-md-3 col-sm-6 col-xs-12 no-padding">
            <div className="service-block text-center">
              <div className="service-icon text-center">
                <i className="tf-ion-ios-copy-outline"></i>
              </div>
              <h3>Information Session</h3>
              <h4>Location: Zoom</h4>
              <p>
                1/20/21  7-8:30 PM
                <br />
                1/21/21  4:30-6 PM
              </p>
            </div>
          </div>
          {/* End Single Service Item */}
          {/* Single Service Item */}
          <div className="col-md-3 col-sm-6 col-xs-12 no-padding">
            <div className="service-block color-bg text-center">
              <div className="service-icon text-center">
                <i className="tf-ion-ios-book-outline"></i>
              </div>
              <h3>Case Workshop</h3>
              <h4>Location: Zoom</h4>
              <p>1/22/21  5-6:00 PM</p>
              <br />
            </div>
          </div>
          {/* End Single Service Item */}
          {/* Single Service Item */}
          <div className="col-md-3 col-sm-6 col-xs-12 no-padding">
            <div className="service-block text-center">
              <div className="service-icon text-center">
                <i className="tf-ion-ios-alarm-outline"></i>
              </div>
              <h3>Application</h3>
              <h4>Location: <a href="apply">Online</a></h4>
              <p>1/23/21  9:00 PM</p>
              <br />
            </div>
          </div>
          {/* End Single Service Item */}
          {/* Single Service Item */}
          <div className="col-md-3 col-sm-6 col-xs-12 no-padding">
            <div className="service-block color-bg text-center">
              <div className="service-icon text-center">
                <i className="tf-ion-ios-people-outline"></i>
              </div>
              <h3>Interviews</h3>
              <h4>Location: Zoom</h4>
              <p>1/25/21 - 1/29/21</p>
              <br />
            </div>
          </div>
          {/* End Single Service Item */}
        </div>
      </div>
    </section>
    {/* ================= End Process Section ================= */}

    {/* ================= Start FAQ Section ================= */}
    <section className="section-sm shaded">
      <div className="container">
        <SectionTitle title="Frequently Asked Questions" hasPadding={true} />
        <Faq />
      </div>
    </section>
    {/* ================= End FAQ Section ================= */}
  </Layout>
)

export default Students
